import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	product: [],
};

const reportServiceSlice = createSlice({
	name: 'reportService',
	initialState: initialState,
	reducers: {
		setReportServiceData: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setReportServiceData, reset } = reportServiceSlice.actions;

export default reportServiceSlice.reducer;